import {
  Element,
  InstallSpec,
  ItemComponent,
  Option,
} from "@p0security/shared/install/types";

const provider = ItemComponent({
  label: "Identity provider",
  description: "Allow headless agents to authenticate as P0-managed identities",
  type: "string",
  maturity: "preview",
  schema: {
    issuer: Element({
      label: "Issuer",
      description:
        "Issuer URL (the `iss` claim) of the identity provider to enroll",
      type: "string",
      step: "new",
      validator: async (_id, field) => {
        try {
          new URL(field);
        } catch {
          return "Issuer must be a valid URL";
        }
      },
    }),
    audiencePattern: Element({
      label: "Audience pattern",
      description:
        "Pattern that a token's audience (the `aud` claim) must match to be accepted",
      type: "string",
    }),
    subjectPattern: Element({
      label: "Subject pattern",
      description:
        "Pattern that a federating token's subject (the `sub` claim) must match to be accepted (leave empty to accept any subject)",
      type: "string",
      optional: true,
    }),
    emailPattern: Element({
      label: "Email pattern",
      description:
        "Pattern that a federating token's email (the `email` claim) must match to be accepted; the email must also be verified (leave empty to accept any email)",
      type: "string",
      optional: true,
    }),
    dynamicRegistration: Element({
      label: "Dynamic registration?",
      description:
        "If set, identities matching this provider will automatically be registered with your gateways; otherwise, identities must be manually pre-registered",
      type: "switch",
    }),
    replayProtection: Element({
      label: "Replay protection",
      description:
        "Whether this provider's tokens may be presented more than once",
      type: "select",
      default: "disabled",
      options: {
        disabled: Option({
          maturity: "preview" as const,
          label: "Allow replay",
          schema: {},
        }),
        strict: Option({
          maturity: "preview" as const,
          label: "Prevent replay",
          schema: {},
        }),
        grace: Option({
          maturity: "preview" as const,
          label: "Allow replay within grace period",
          schema: {
            graceSeconds: Element({
              label: "Grace period (seconds)",
              description:
                "How long after an assertion is first seen it may still legitimately be re-presented",
              type: "string",
              validator: async (_id, field) => {
                const n = Number(field);
                if (!Number.isFinite(n) || n <= 0) {
                  return "Grace period must be a positive number of seconds";
                }
              },
            }),
          },
        }),
      },
    }),
  },
});

export const IdentityProviderComponents = InstallSpec({ provider });
